import { createFormAction } from "redux-form-saga";
export const AUTO_FORM_KEY = "AUTO_FORM_KEY";
export const AutoFormAction = createFormAction(AUTO_FORM_KEY);

